import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { GetAdminV1StoresStoreIdSectionsIdPreviewParams } from '@nucleus-commerce/api-client/admin';

import { sectionsApi, type SectionListParams } from '../api/content-api';

import { contentKeys } from './content-keys';

export function sectionListQueryOptions(storeId: string, params: SectionListParams) {
  return queryOptions({
    queryKey: contentKeys.sectionList(storeId, params),
    queryFn: () => sectionsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useSections(storeId: string, params: SectionListParams) {
  return useQuery(sectionListQueryOptions(storeId, params));
}

export function sectionQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: contentKeys.sectionDetail(storeId, id),
    queryFn: () => sectionsApi.get(storeId, id),
  });
}

export function useSection(storeId: string, id: string) {
  return useQuery(sectionQueryOptions(storeId, id));
}

/** The storefront payload with drafts; fetched on demand when the preview panel opens. */
export function useSectionPreview(
  storeId: string,
  id: string,
  params: GetAdminV1StoresStoreIdSectionsIdPreviewParams,
  enabled: boolean,
) {
  return useQuery({
    queryKey: contentKeys.sectionPreview(storeId, id, params),
    queryFn: () => sectionsApi.preview(storeId, id, params),
    enabled,
    staleTime: 0,
  });
}
